<div class="overlay-content display-column">
  <div class="loading-container">
    <img
      src="/assets/video/loading/Code_Cuisine_Loading_Spinner.gif"
      alt="Generating recipe..."
      class="loading-gif"
    >
  </div>
  <p class="display-center-center">Generating...</p>
</div>
